import { Component, ChangeDetectionStrategy } from '@angular/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramResult } from '../../types';

import { BACKGROUND_COLORS, ICON_COLORS } from './constants';

@Component({
  selector: 'lp-result-dialog',
  templateUrl: './result-dialog.component.html',
  styleUrls: ['./result-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultDialogComponent extends BaseResizableComponent {
  readonly context = injectContext<TuiDialogContext<void, LoyaltyProgramResult>>();

  close() {
    this.context.completeWith();
  }

  get result() {
    return this.context.data.type;
  }

  get backgroundColor(): string | null {
    return BACKGROUND_COLORS[this.result];
  }

  get color(): string | null {
    return ICON_COLORS[this.result];
  }
}
